import gql from 'graphql-tag';

export const queryForMonLogWorkTypes = gql`
  query queryForMonLogWorkTypes(
    $limit: Int
    $page: Int
    $query: DataTableSortOrQuery
    $sort: DataTableSortOrQuery
  ) {
    queryForMonLogWorkTypes(
      limit: $limit
      page: $page
      query: $query
      sort: $sort
    ) {
      items {
        id
        name
        category
      }
      totalRecords
    }
  }
`;
